import React, { useState, useEffect, useRef } from 'react';
import styles from './kdsExpoStationCards.module.scss';
import cn from 'classnames';
import ExpoTime from './expoTime';
import kdsStyles from '../common/KDSCSS/kdsScreens.module.scss'
import cancelIcon from '@assets/images/KDSICONS/cancelIcon.svg';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import Modal from '@components/common/Modal';
import moment from 'moment';
import LongPressKds from '@components/common/LongPressButton/LongPressKds';


const StationCard = ({
    check,
    groupItems,
    bumpApiCall,
    prepStartAll,
    searchOverlay,
    convertUTCDateToLocalDate,
    setSelectedObjects,
    selectedObjects,
    bumpApiSelected,
    getPrepCompletedTime,
    duplicateDeviceIds,
    getWarning,
    colorCoding,
    setOrderModeData,
    setDragRushModalData,
    deviceInfo
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const kdsSettings = deviceInfo?.deviceGroup?.kdsSettings;
    const [isBumpConfirm, setBumpConfirmationModal] = useState(false);

    // *****************

    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [containerRef.current]);

    const handleScroll = () => {
    }; 

    const bumpSelected = (check, checkPrepId) => {
        let items = [];
        for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
            const element = selectedObjects[checkPrepId][i];
            items.push({
                entityId: element.entityId,
                isModifier: element.isModifier,
            });
        }
        bumpApiSelected(check, 'expoSelectedBump', items);
        for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
            const element = selectedObjects[checkPrepId][i];
            setSelectedObjects(prevState => {
                return {
                    ...prevState, // copy the previous state
                    [checkPrepId]: prevState[checkPrepId].filter(
                        obj => obj.entityId !== element.entityId
                    ), // remove the object from the array with the corresponding id
                };
            });
        }
    };

    const handleCheckboxChange = (event, item, checkId) => {
        const selectedObject = { id: checkId }; // create a new object with an id property

        if (event.target.checked) {
            setSelectedObjects(prevState => {
                return {
                    ...prevState, // copy the previous state
                    [selectedObject.id]: [...(prevState[selectedObject.id] || []), item], // add the selected object to the array with the corresponding id
                };
            });
        } else {
            setSelectedObjects(prevState => {
                return {
                    ...prevState, // copy the previous state
                    [selectedObject.id]: prevState[selectedObject.id].filter(
                        obj => obj.entityId !== item.entityId
                    ), // remove the object from the array with the corresponding id
                };
            });
        }

        // log the selected objects array for debugging purposes
    };



    const customStatusColor = buildStatus => {
        return buildStatus === 2
            ? styles.bgGrey
            : buildStatus === 5
                ? styles.bgBlue
                : buildStatus === 8
                    ? styles.bgSuccess
                    : styles.textColor;
    };

    const individualItemSquire = (
        kdsStatus,
        expoStartDate,
        plannedCompleteDate
    ) => {
        const currentTime = new Date().getTime();
        const plannedExpoCompleteDate = convertUTCDateToLocalDate(
            new Date(plannedCompleteDate)
        ).getTime();
        if (
            kdsStatus == 2 &&
            (!plannedExpoCompleteDate || currentTime <= plannedExpoCompleteDate)
        ) {
            return '#767676';
        } else if (kdsStatus == 2 && currentTime >= plannedExpoCompleteDate) {
            return '#767676';
        } else if (kdsStatus == 8) {
            return '#18BD63';
        } else if (kdsStatus == 5) {
            return '#0060FF';
        }
        return '#d1d1d1';
    };
    const onClose = () => {
        setIsOpen(false);
    };

    const checkBoxCheck = (data, id) => {
        if (data != undefined) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.entityId === id) {
                    return true;
                }
            }
        }
        return false;
    };

    const getTime = date => {

        if (date === null) {
            return true;
        }
        const momentTime = moment.utc(date).local();
        const currentTime = moment();
        return currentTime > momentTime ? true : false;
    };
    const getSortData = data => {
        const obj = {};

        data.forEach(item => {
            let { seatId } = item;

            if (!kdsSettings?.groupBySeat) {
                seatId = 1234;
            }

            if (!obj[seatId]) {
                obj[seatId] = [];
            }

            obj[seatId].push(item);
        });
        return obj;
    };

    const renderItemModifiers = (item, modPadding) => {
        const modifiers = item?.modifiers?.map((modifierItem, modifierIndex) => {
            return (
                <div key={modifierItem.name + modifierIndex} className={`row mx-0 w-100 ${modifierIndex < item.length - 1 ? 'pb-2' : ''}`} style={{ fontSize: 'max(1.1vw, 1.1vh)', }}>
                    <div className="w-10">
                        {(modifierItem.prepStatus != 0 || modifierItem.buildStatus != 0) &&
                            <input type='checkbox' style={{ width: '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, modifierItem, check.id)} checked={checkBoxCheck(selectedObjects[check.id], modifierItem?.entityId)} disabled={modifierItem.expoStatus === 8} />
                        }
                    </div>
                    {(modifierItem.buildStatus != 0) ?
                        <LongPressKds
                            className={cn("col-6 text-left", kdsStyles.modifiers)} style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px', textDecoration: modifierItem.expoStatus === 8 ? "line-through" : '', textDecorationColor: 'black', color: modifierItem?.allergy ? 'red' : (getTime(modifierItem.plannedStartDate) ? 'black' : 'gray') }}
                            onLongPress={() => handleLongPress(check?.storeId, modifierItem?.itemId, modifierItem?.name, true, modifierItem, check)}
                            onClick={() => { }}
                        >
                            -  {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp;{modifierItem.name}
                            <div className="text-left pl-2" style={{ color: '#CE842A', fontSize: 'max(1.1vw, 1.1vh)', width: 'max-content' }}>
                                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
                            </div>
                        </LongPressKds> :
                        <LongPressKds
                            className={cn("col-6 text-left", kdsStyles.modifiers)} style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px', textDecoration: modifierItem?.expoStatus === 8 ? 'line-through' : '', textDecorationColor: 'black', color: modifierItem?.allergy ? 'red' : (getTime(modifierItem.plannedStartDate) ? 'black' : 'gray') }}
                            onLongPress={() => handleLongPress(check?.storeId, modifierItem?.itemId, modifierItem?.name, true, modifierItem, check)}
                            onClick={() => { }}
                        >
                            -  {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''}&nbsp;{modifierItem.name}
                            <div className="text-left pl-2" style={{ fontSize: 'max(1.1vw, 1.1vh)', color: '#CE842A', width: 'max-content' }}>
                                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
                            </div>
                        </LongPressKds>
                    }
                    {(modifierItem.plannedStartDate || modifierItem.plannedBuildStartDate) ?
                        <div className="col-md px-1 text-right d-flex justify-content-end align-items-center">
                            {getWarning(modifierItem) && colorCoding(modifierItem) && <div className='pr-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={colorCoding(modifierItem)}>
                                    <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                                    <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                                    <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                                </svg>
                            </div>}
                            <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquire(modifierItem.prepStatus, check.startDate, check.plannedStartDate) }} aria-hidden="true" />
                            <div className='h-100' style={{ width: "1.5px" }} />
                            <i className={cn(`fa fa-circle fs-12 ${customStatusColor(modifierItem.buildStatus)}`)} aria-hidden="true" />
                            <span className="ml-1" style={{ color: 'black' }}>{modifierItem.prepStatus != 8 ? <ExpoTime date={modifierItem.plannedStartDate} /> : getPrepCompletedTime(modifierItem)}</span>
                        </div> : <div className='col-3'></div>}
                    {modifierItem?.modifiers && modifierItem.modifiers.length > 0 && renderItemModifiers(modifierItem, modPadding + 10)}
                </div>
            )
        });
        return modifiers;
    }

    const getheaderColor = (items, headerColorId) => {
        items.forEach(item => {
            if (item.warningColorId > headerColorId) {
                headerColorId = item.warningColorId;
            }
            if (headerColorId === 4) return headerColorId;
            if (item?.modifiers.length > 0) {
                headerColorId = getheaderColor(item.modifiers, headerColorId);
                if (headerColorId === 4) return headerColorId;
            }
        });
        return headerColorId;
    }

    const rendercheckItems = (items, isModifier) => {
        const itemData = items?.map(item => {
            let modData = [];
            if (item?.modifiers.length > 0) modData = rendercheckItems(item.modifiers, true);
            const warningColorId = !getTime(item.plannedStartDate) ? 0 : item.prepStatus == 0 && item.buildStatus == 0 ? isModifier ? 0 : 1 : getWarning(item) ? colorCoding(item) : 1;
            return { ...item, modifiers: modData, warningColorId: !warningColorId || warningColorId === 'black' ? 1 : warningColorId === 'yellow' ? 2 : warningColorId === '#F49F40' ? 3 : warningColorId === '#FF6464' ? 4 : warningColorId }
        });
        return itemData;
    }

    const handleLongPress = (storeId, itemId, itemName, isModifier, item, check, index) => {
        setOrderModeData({ isOpenn: true, isPdfOpen: false, storeId: storeId, itemId: itemId, itemName: itemName, isModifier: isModifier || false });
        setDragRushModalData({
            isOpen: false,
            prepStatus: item?.prepStatus,
            storeId: storeId, itemId: itemId, itemName: itemName,
            data: item,
            checkData: {
                checkHeaderId: check?.checkHeader?.id,
                checkPrepId: check?.id,
                employeeId: check?.checkHeader?.employeeId,
            }
        })
    };

    return (
        <div
            className={cn('h-100 w-100', searchOverlay ? styles.opacity : '', styles.p3)}
        >
            <div
                className={cn(
                    'h-100 od-container-card-border od-container-card-background',
                    styles.backgroundColor,
                    styles?.expoStationCards
                )}
                style={{ border: `2px solid ${duplicateDeviceIds[check?.expoDeviceId]}` }}
            >
                <div
                    className={cn(`fs-12 overflowY Od-container-card-background`)}
                    ref={containerRef}
                    style={{ height: '48vw' }}
                >
                    {Object.values(getSortData(groupItems))?.map((el) => {
                        return (

                            <>
                                {kdsSettings?.groupBySeat && el[0]?.seatNumber &&
                                    <div className='w-100 text-center fw-500' style={{ backgroundColor: '#FFFADD', border: kdsSettings?.groupBySeat && '2px solid #BEB893', fontSize: '10px', color: 'black' }}>
                                        <span>
                                            Seat {el[0]?.seatNumber}
                                        </span>
                                        {
                                            el[0]?.seatName && (
                                                <span className='ml-1'>
                                                    ({el[0]?.seatName})
                                                </span>
                                            )
                                        }
                                    </div>
                                }
                                <>
                                    {
                                        el?.map((item, index) => {

                                            return (
                                                <div key={`${item.id}-${index}`} className={cn('row mx-0 w-100 od-container-card-background pl-1 pr-1', styles.p3)} style={{ borderBottom: index < groupItems.length - 1 ? '1px solid #C9C9C9' : '', paddingTop: '7px' }}>
                                                    <div className="w-10">
                                                        <input
                                                            type="checkbox"
                                                            style={{ width: '100%' }}
                                                            className={cn('', styles.checkbox)}
                                                            onChange={event =>
                                                                handleCheckboxChange(event, item, check.id)
                                                            }
                                                            checked={checkBoxCheck(
                                                                selectedObjects[check.id],
                                                                item.entityId
                                                            )}
                                                            disabled={item?.expoStatus === 8}
                                                        />
                                                    </div>
                                                    <LongPressKds
                                                        className={cn("col-6 px-1 pb-1", kdsStyles.item)}
                                                        style={{
                                                            textDecoration:
                                                                item?.expoStatus === 8 ? 'line-through' : '',
                                                            textDecorationColor: 'black',
                                                            color: item?.allergy ? 'red' : (getTime(item.plannedStartDate) ? 'black' : 'gray'),
                                                        }}
                                                        onLongPress={() => { handleLongPress(check.storeId, item?.itemId, item?.name, false, item, check, index) }}
                                                        onClick={() => { }}
                                                    >
                                                        &nbsp;&nbsp;{item?.quantity > 1 ? item?.quantity + 'x' : '1x'}&nbsp;&nbsp;
                                                        {item.name}
                                                        <div
                                                            className="text-left fs-12 pl-2"
                                                            style={{ color: '#CE842A', width: 'max-content' }}
                                                        >
                                                            {`${item.comment ? `- ${item.comment}` : ''}`}
                                                        </div>
                                                    </LongPressKds>
                                                    <div
                                                        className="col-md px-1 text-right d-flex justify-content-end align-items-center"
                                                        style={{ fontSize: 'max(1.1vw, 1.1vh)' }}
                                                    >
                                                        {item?.expoStatus !== 0 && getTime(item.plannedStartDate) ? (
                                                            <>
                                                                {getWarning(item) && colorCoding(item, check?.startDate, check?.plannedExpoStartDate) && <div className='pr-1'>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={colorCoding(item, check?.startDate, check?.plannedExpoStartDate)}>
                                                                        <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                                                                        <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                                                                        <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                                                                    </svg>
                                                                </div>}
                                                                <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquire(item?.prepStatus, check.startDate, check.plannedStartDate) }} aria-hidden="true" />
                                                                <div className='h-100' style={{ width: "1.5px" }}></div>
                                                                <i className={cn(`fa fa-circle fs-12 ${customStatusColor(item.buildStatus)}`)} aria-hidden="true" />
                                                            </>
                                                        ) : (
                                                            <div
                                                                className={cn('box align-item-center ')}
                                                                style={{
                                                                    height: '1rem',
                                                                    width: '13px',
                                                                    marginRight: '0.6rem',
                                                                    marginBottom: '0.1rem',
                                                                }}
                                                            >
                                                                {item?.expoStatus == 8 || (item?.prepStatus == 0 && item?.buildStatus == 0) ? (
                                                                    <></>
                                                                ) : (
                                                                    <i
                                                                        className="fa fa-clock"
                                                                        style={{ color: 'black', fontSize: '0.9rem' }}
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        )}
                                                        <div className='ml-1' style={{ color: 'black' }}><ExpoTime date={item.plannedStartDate} /></div>
                                                    </div>
                                                    {item?.modifiers && item?.modifiers.length > 0 && renderItemModifiers(item, 25)}
                                                </div>
                                            );

                                        })
                                    }
                                </>
                            </>

                        )
                    })}
                </div>

                <div className='row mx-0 w-100 text-center align-content-end position-absolute' style={{
                    bottom: '0%',
                    cursor: 'pointer',
                    background: '#D9D9D9'
                }}>
                </div>

                <Modal isOpen={isOpen} isModalCenter customClass2={styles.maxWidth} customClass3={styles.rad}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <div className="px-2 py-2 text-right">
                            <i
                                role="presentation"
                                onClick={() => onClose()}
                                className="fa fa-times fs-30"
                                aria-hidden="true"
                            />
                        </div>
                        <div className="text-center mb-5">
                            <button
                                className="w-50 od-btn-primary btn20 "
                                style={{
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    border: 'solid',
                                    paddingBottom: '22px',
                                }}
                                onClick={() => {
                                    prepStartAll(check, 'expo');
                                    setIsOpen(false);
                                }}
                            >
                                Bump Items
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
            <Modal
                isOpen={isBumpConfirm}
                isModalCenter customClass2={styles.bumpModalMaxWidth}
                customClass3={styles.rad}
            >
                <div className={styles.bumpConfirmationModal}>
                    <div className="px-2 py-2 text-right w-100">
                        <img role='button' src={cancelIcon} alt="cancelIcon" width="40px" onClick={() => setBumpConfirmationModal(false)} />

                    </div>
                    <div className={cn('text-center text-dark mb-3 ml-5 mr-5 fw-600')}>
                        <p>{CUSTOM_MESSAGES().KDS_BUMP_CONFIRMATION}</p>
                        <div>
                            <button
                                className={cn('rounded od-btn-primary color-dark btn-ripple btn35 w-40 m-3 border-dark')}
                                style={{ border: '1px solid black' }}
                                onClick={() => setBumpConfirmationModal(false)}
                            >
                                {LABEL().NO}
                            </button>
                            <button
                                style={{ border: '1px solid #0060FF' }}
                                className={cn('rounded od-btn-primary color-white btn-ripple btn35 w-40 m-3', styles.popUpBtnColor)}
                                onClick={() => {
                                    setBumpConfirmationModal(false);
                                    selectedObjects?.hasOwnProperty(check.id + '') && selectedObjects[check.id]?.length > 0 ?
                                        bumpSelected(check, check.id + '') : bumpApiCall(check, 'expo');
                                }}
                            >
                                {LABEL().YES}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};


export default StationCard;
